/// <reference types="@types/googlemaps" />
import {
  Component,
  OnInit,
  Input,
  Output,
  TemplateRef,
  ElementRef,
  ViewChild,
  EventEmitter,
} from '@angular/core';
import {
  FormGroup,
  FormControl,
  FormBuilder,
  Validators,
  FormArray,
} from '@angular/forms';
import { _ } from 'underscore';
import {
  trigger,
  state,
  style,
  animate,
  transition,
  group,
} from '@angular/animations';
import { CommercialService } from '../../commercial.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
declare var google: any;
import { GooglePlaceDirective } from 'ngx-google-places-autocomplete/ngx-google-places-autocomplete.directive';

@Component({
  selector: 'app-cq22',
  templateUrl: './cq22.component.html',
  styleUrls: [
    './cq22.component.css',
    '../commercial-questionnaire.component.css',
  ],
  animations: [
    trigger('flyInOut', [
      state(
        'in',
        style({
          transform: 'translateX(0)',
          opacity: 1,
        })
      ),
      transition('void => *', [
        style({ transform: 'translateX(100px)', opacity: 0 }),
        group([
          animate(
            '0.4s 0.1s ease',
            style({
              transform: 'translateX(0)',
            })
          ),
          animate(
            '0.4s ease',
            style({
              opacity: 1,
            })
          ),
        ]),
      ]),
      transition('* => void', [
        group([
          animate(
            '0.4s ease',
            style({
              transform: 'translateX(50px)',
            })
          ),
          animate(
            '0.4s 0.2s ease',
            style({
              opacity: 0,
            })
          ),
        ]),
      ]),
    ]),
  ],
})
export class Cq22Component implements OnInit {

  @Input() data: any;

  question;
  questions;
  user_bot = false;
  disableButton = true;
  clickedOnce = false;
  formatedAddress;
  userResponses = [];
  questionObj;
  deviceWidth;
  // registerForm: FormGroup;
  submitted = false;
  showTyping = false;
  userObj = {
    firstName: '',
    lastName: '',
    email: '',
    confirmEmail: '',
    phone: '',
    title: '',
    billingAddress: '',
    suite: '',
    accepted: false,
  };
  zipcode;
  componentForm = {
    street_number: 'short_name',
    route: 'long_name',
    locality: 'long_name',
    administrative_area_level_1: 'short_name',
    country: 'long_name',
    postal_code: 'short_name',
  };
  // For ngx-google-autocomplete
  lat;
  lng;
  options = {
    types: [],
    componentRestrictions: { country: 'US' },
  };
  geoMapAddress;
 bounds: google.maps.LatLngBounds;
  markers: google.maps.Marker[];
  infoWindow: google.maps.InfoWindow;
  modalRef: BsModalRef;
  @ViewChild('appPhoneNumber', { static: true }) inputEl: ElementRef;
  private regex: RegExp = new RegExp(/^\d*\.?\d{0,4}$/g);
  @ViewChild('places', { static: true }) places: GooglePlaceDirective;
  @ViewChild('search', { static: true }) public searchElement: ElementRef;
  @ViewChild('Suite_mob', { static: true }) inputEl_mob: ElementRef;
  @ViewChild('template', { static: true }) template: ElementRef;
  @ViewChild('noservice', { static: true }) noService: ElementRef;
  @Output() selectOn: EventEmitter<any> = new EventEmitter();
  constructor(
    private commercialService: CommercialService,
    private formBuilder: FormBuilder,
    private modalService: BsModalService
  ) {
    this.questions = this.commercialService.getQues();
    this.deviceWidth = this.commercialService.deviceWidth;
    this.userResponses = this.commercialService.userResponse.userResponses;
  }
  public handleAddressChange2(address) {
    // this.isAddressSelected = true;

  
    this.geoMapAddress = address;
    this.commercialService.address = address;
    if (typeof address.geometry.location.lng === 'number') {
      this.lng = address.geometry.location.lng;
      this.lat = address.geometry.location.lat;
    } else {
      this.lng = address.geometry.location.lng();
      this.lat = address.geometry.location.lat();
    }

    this.getFormattedAddress(address);
  }
  
  getFormattedAddress(place) {
    this.userObj.billingAddress = place.formatted_address;

    let addressValue = '';
    for (let i = 0; i < place.address_components.length; i++) {
      const addressType = place.address_components[i].types[0];
      if (this.componentForm[addressType]) {
        const val =
          place.address_components[i][this.componentForm[addressType]];
        addressValue = addressValue + addressType + ':' + val + ';';
      }
      if (place.address_components[i].types[0] === 'postal_code') {
        this.zipcode = place.address_components[i].long_name;
      }
    }
  
   
  }

  ngOnInit() {
   
      const autocomplete2 = new google.maps.places.Autocomplete(
        document.getElementById('autocomplete2'),
        { types: ['geocode'] }
      );
      google.maps.event.addListener(autocomplete2, 'place_changed', () => {
        this.selectOn.emit(this.getFormattedAddress(autocomplete2.getPlace()));
        // }
      });

   

    this.commercialService.currentId = this.data;
    for (let i = 0; i < this.questions.length; i++) {
      if (this.questions[i]._id === this.data) {
        this.question = this.questions[i].com_question;
        this.questionObj = this.questions[i];
      }
    }
    if (this.userResponses.length > 0 && !_.isEmpty(this.questionObj)) {
      const obj = _.findWhere(this.userResponses, {
        com_question_id: this.questionObj._id,
      });
      if (!_.isEmpty(obj)) {
        this.userObj = {
          firstName: obj.fieldValue.firstName,
          lastName: obj.fieldValue.lastName,
          email: obj.fieldValue.email,
          confirmEmail: obj.fieldValue.confirmEmail,
          phone: obj.fieldValue.phone,
          title: obj.fieldValue.title,
          billingAddress: obj.fieldValue.billingAddress,
          suite: obj.fieldValue.suite,
          accepted: obj.fieldValue.accepted,
        };
        this.user_bot = true;
        this.disableButton = false;
        if (this.deviceWidth < 768) {
          this.next();
        }
      }
    }
    $('#phone').keypress(function (e) {
      if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
        return false;
      }
    });
  }
  checkboxEvnt(event, formValid) {
    if (formValid) {
      if (event.target.checked === true) {
        this.userObj.accepted = event.target.checked;
        // this.user_bot = true;
        this.disableButton = false;
      } else {
        this.userObj.accepted = event.target.checked;
        this.user_bot = false;
        this.disableButton = true;
      }
      //  // console.log.log(formValid);
    } else {
      event.target.checked = false;
      this.user_bot = false;
      this.clickedOnce = true;
      alert('Please enter all mandatory fields.');
    }
  }

  mailMe(
    mail // <--- element on which you need to apply click
  ) {
    mail = document.createElement('a');
    mail.href = 'mailto:hello@honestgorilla.com?subject=Question&body=Hi';
    mail.click();
  }

  checkboxConfirm(event, formValid) {
    if (formValid && event.target.checked) {
      this.user_bot = true;
      this.save();
      this.next();
    } else {
      this.user_bot = false;
      this.commercialService.unSelectService({ currentId: this.data });
    }
  }

  onSubmit(event, formValid) {
    if (formValid) {
      this.save();
      this.next();
    }
  }
  titleCase(str) {
    str = str.toLowerCase().split(' ');
    for (let i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(' ');
  }

  onKeyPress(event: KeyboardEvent) {
    // Allow Backspace, tab, end, and home keys
    if (event['data'] == null) {
      return;
    }
    let current: string = this.inputEl.nativeElement.value;
    let next: string = current;
    let nextWithout = next.replace(new RegExp('-', 'g'), '');
    if (nextWithout && !String(nextWithout).match(this.regex)) {
      event.preventDefault();
    } else {
      if (next.length == 3) {
        this.userObj.phone = next + '-';
        event.preventDefault();
      } else if (next.length == 7) {
        this.userObj.phone = next + '-';
        event.preventDefault();
      }
    }
  }

  onPaste(event) {
    let next = event.clipboardData.getData('Text');
    let ph_val = next.replace(/\D[^\.]/g, '');
    let phone =
      ph_val.slice(0, 3) + '-' + ph_val.slice(3, 6) + '-' + ph_val.slice(6);
    this.userObj.phone = phone;
    event.preventDefault();
  }

  save() {
    this.userObj.firstName = this.titleCase(this.userObj.firstName);
    this.userObj.lastName = this.titleCase(this.userObj.lastName);
    const Obj = {
      com_question_id: this.data,
      fieldName: 'contactForm',
      fieldValue: this.userObj,
    };
    this.commercialService.updateResponses(Obj);
  }

  next() {
    this.commercialService.messageService({ currentId: this.data });
  }
  openModalWithClass(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-lg' })
    );
  }
}
